<!-- 日告警数量 -->
<template>
	<divBox class="dayTimeBox" :title="'日告警数量'">
		<Chart :cdata="cdata" :width="'450'" :height="'390'" />
	</divBox>
</template>

<script>
import divBox from '../../components/divBox.vue'
import Chart from '../../components/charts/chart.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
	data() {
		return {
			cdata: {
				category: [],
				rateData: [],
				id: "carAddChart",
				legendData: [{
						name: "上月",
						icon: 'roundRect',
					},
					{
						name: "本月",
						icon: 'roundRect',
					},
				],
				series: [{
						name: "上月",
						type: "line",
						smooth: true,

						symbolSize: 1,
						// yAxisIndex: 1,
						itemStyle: {
							color: "rgba(95, 189, 255, 1)"
						},
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					},
					{
						name: "本月",
						type: "line",
						smooth: true,

						symbolSize: 1,
						// yAxisIndex: 1,
						itemStyle: {
							color: "rgba(255, 90, 134, 1)"
						},
						data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					},
				],
				yAxisname: "(次)"
			}
		};
	},
	components: {
		divBox,
		Chart
	},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {},
	methods: {
		getData(data) {
			this.selectDailyAlarm(data);
		},
		selectDailyAlarm(data = {}) {
			let _this = this;
			let params = {};
			if (data) {
				params = {
					"enCode": "TiDB-shengshiqu-rigaojingshuliang",
					"@province": data.province || data.city || data.district
				}
			} else {
				params = {
					"enCode": "TiDB-quanguo-rigaojingshuliang" //TiDB-全国-日告警数量
				}
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					console.log("日告警数量", res)
					let last_alarmNum = [];
					let cur_alarmNum = [];
					let xList = [];
					res.map(item => {
						last_alarmNum.push(item.last_alarmNum);
						cur_alarmNum.push(item.cur_alarmNum);
						xList.push(item.cur_date);
					})
					_this.cdata.category = xList;
					_this.cdata.series[0].data = last_alarmNum;
					_this.cdata.series[1].data = cur_alarmNum;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	}
}
</script>

<style lang="scss" scoped>
.dayTimeBox {
	width: 100%;
	height: 515px;
	box-sizing: border-box;
	padding: 10px 20px 40px 20px;
}
</style>